import React from "react";
import { Row, Col } from "react-bootstrap";
import "../assets/css/ingredients.css";

function ingredients() {
    return (
        <div>
            <div className="logo-container ingredients-wrapper">
                <img
                    loading="lazy"
                    src="https://northshoresoapworks.com/images/bird.png"
                    className="bird-img bird-1"
                    alt="Bird"
                />
                <img
                    loading="lazy"
                    src="https://northshoresoapworks.com/images/logo.webp"
                    className="aboutus-logo"
                    width="1018"
                    height="255"
                    alt="Logo"
                />
                <img
                    loading="lazy"
                    src="https://northshoresoapworks.com/images/bird.png"
                    className="bird-img"
                    alt="Bird"
                />
            </div>
            <p className="text-center mb-4">At North Shore Soapworks we use only premium high-quality ingredients
                to create and customize our beautifully handcrafted masterpieces.</p>

            <div className="ingredients-section">
                <Row className="m-0 py-4">
                    <Col md={2} className="ingredients-left">
                        <img className="ingredient-side-img" src="https://northshoresoapworks.com/images/Pour.jpg" alt="Pour" />
                    </Col>
                    <Col md={8} className="ingredients-center">

                        <h1 className="ingredient-header">PURE SOAP INGREDIENTS</h1>
                        <p className="text-center">Our glycerine soap base is made with all vegetable oil
                            and contains no alcohol or harmful products to dry the skin. </p>
                        <Row className="m-0">
                            <Col className="ingredients" sm={3}>
                                Water <br />
                                Glycerin <br />
                                Sorbitol <br />
                                Sodium Stearate <br />
                                Sodium Laurate <br />
                            </Col>
                            <Col className="ingredients" sm={3}>
                                Glyceryl Laurate <br />
                                Cocamidopropyl Bethune <br />
                                Sodium Thiosulfate <br />
                                Titanium Dioxide <br />
                                Citric Acid <br />
                            </Col>
                            <Col className="ingredients" sm={3}>
                                Propylene Glycol <br />
                                Sodium Oleate <br />
                                Sodium Myristate <br />
                                Sodium Chloride <br />
                                Sodium Citrate <br />
                            </Col>
                            <Col className="ingredients" sm={3}>
                                Cocos Nucifera (coconut) Oil <br />
                                Tetrasodium Iminodisuccinate <br />
                                C12-18 Fatty Acid <br />
                                Tetrasodium Etidronate <br />
                            </Col>
                        </Row>

                    </Col>
                    <Col md={2} className="ingredients-right">
                        <img className="ingredient-side-img" src="https://northshoresoapworks.com/images/cut.jpg" alt="lotion" />
                    </Col>
                </Row>

                <Row className="m-0 py-4">
                    <Col md={2} className="ingredients-left">
                        <img className="ingredient-side-img" src="https://northshoresoapworks.com/images/lotion-2.jpg" alt="Pour" />
                    </Col>
                    <Col md={8} className="ingredients-center">

                        <h1 className="ingredient-header">LOTION INGREDIENTS</h1>
                        <p className="text-center">All of our products are made using high quality ingredients.</p>
                        <Row className="m-0">
                            <Col className="ingredients" sm={4}>
                                Water (Aqua) <br />
                                Glycerine <br />
                                Cereal Alcohol & Ceteareth-20 <br />
                                Sunflower oil <br />
                                Shea butter <br />
                            </Col>
                            <Col className="ingredients" sm={4}>
                                Vitamin E <br />
                                Carbomer <br />
                                Citric acid <br />
                                Essential oils <br />
                                Fragrance oils <br />
                            </Col>
                            <Col className="ingredients" sm={4}>
                                Glyceryl Monostearate <br />
                                Medium chain triglyceride <br />
                                Cetyl alcohol <br />
                                Sweet almond oil <br />
                                Phenoxyethano <br />
                            </Col>
                        </Row>
                    </Col>
                    <Col md={2} className="ingredients-right">
                        <img className="ingredient-side-img" src="https://northshoresoapworks.com/images/lotion-3.jpg" alt="Pour" />
                    </Col>
                </Row>
                <Row className="m-0 py-4">
                    <Col md={2} className="ingredients-left">
                        <img className="ingredient-side-img" src="https://northshoresoapworks.com/images/liquid-soap.jpg" alt="Pour" />
                    </Col>
                    <Col md={8} className="ingredients-center">

                        <h1 className="ingredient-header">LIQUID WASH INGREDIENTS</h1>
                        <p className="text-center">Our liquid wash is nontoxic and eco-friendly, which means that it is free from harmful chemicals. It is good for both skin and the environment.</p>
                        <Row className="m-0">
                            <Col className="ingredients" sm={6}>
                                Water (Aqua) <br />
                                Cocoamidopropyl Hydroxysultaine <br />
                                Decyl Glucoside <br />
                                Cocoamidopropyl Betaine <br />
                                Hydrolyzed Soy Protein <br />
                            </Col>
                            <Col className="ingredients" sm={6}>
                                DL Panthenol <br />
                                PEG 150 Pentaerythrityl Tetrastearate Raw material <br />
                                Phenoxyethanol <br />
                                PEG-7 Glyceryl Cocoate <br />
                            </Col>
                        </Row>
                    </Col>
                    <Col md={2} className="ingredients-right">
                        <img className="ingredient-side-img" src="https://northshoresoapworks.com/images/lotion.jpg" alt="Pour" />
                    </Col>
                </Row>
                <p className="text-center mt-4">
                    OUR SOAPS DO <b>NOT</b> CONTAIN: <br />
                    surfactants - propylene glycol - sodium laurel sulfate - sodium laureth sulphate. <br />
                    Neutral pH of approximately 8.0 to 9.0. - 100% vegetable based and biodegradable -  No animal testing - Vegan & kosher certified
                </p>
            </div>
            <div className="ingredients-section">
                <Row className="m-0 py-4">
                    <Col md={2} className="ingredients-left">
                        <img className="ingredient-side-img" src="https://northshoresoapworks.com/images/oil-2.jpg" alt="Pour" />
                    </Col>
                    <Col md={8} className="ingredients-center">

                        <h1 className="ingredient-header">Oils</h1>
                        <h5 className="text-center my-2">Carrier Oils</h5>
                        <p>
                            Carrier oils are also referred to as "vegetable oils" and "base oils". They have extensive applications in aromatherapy because they are used to dilute essential oils or absolutes for safe topical application. They are also used in the manufacturing of cold-processed soaps and for massages by licensed massage therapists. Each carrier oil has different properties, and the choice of a carrier oil can depend on the benefit being sought.
                        </p>
                        <p>Despite also being referred to as vegetable oils, not all carrier oils are derived from vegetables. Some are pressed from seeds, nuts, or kernels. They have also earned the name “fixed oils” because they remain fixed on the skin. This means that, unlike essential oils, they do not quickly evaporate from the skin surface or have the strong natural scent of plants which makes them ideal for controlling essential oil, concentration, and reducing the strength of an essential oils aroma without altering cosmetic properties.</p>


                    </Col>
                    <Col md={2} className="ingredients-right">
                        <img className="ingredient-side-img" src="https://northshoresoapworks.com/images/oil.jpg" alt="Pour" />
                    </Col>
                </Row>
                <Row className="m-0 py-4">
                    <Col md={2} className="ingredients-left">
                        <img className="ingredient-side-img" src="https://northshoresoapworks.com/images/oil-3.jpg" alt="Pour" />
                    </Col>
                    <Col md={8} className="ingredients-center">
                        <h5 className="text-center my-2">Essential Oils/Fragrance Oils</h5>
                        <p>
                            Essential oils, also referred to as “aromatherapy oils”, are the highly concentrated, volatile, aromatic, natural essences of plants. The purest essential oils come from the carefully cultivated and wild, grown plants from climactic and geographic regions throughout the world. Essential oils are pure, undiluted, essences, extracted directly from a variety of flowers, fruits, leaves, barks, roots, herbs, and spices.
                        </p>
                        <p>Fragrance oils are manufactured in a lab and are composed of different aromatic substances. Our fragrance oils are specifically formulated for both skin and hair formulations. The scents are extremely rich, complex and long lasting. Fragrance oils are synthetically compounded and should not be confused with 100% natural essential oils. All of our fragrance oils are paraben free and phthalate free which makes them safer for you and the environment. At North Shore Soapworks we use a combination of fragrance and essential  oils in the majority of our products. "Harmony", "lavender", "energy" use pure essential oils only. </p>

                    </Col>
                    <Col md={2} className="ingredients-right">
                        <img className="ingredient-side-img" src="https://northshoresoapworks.com/images/oil-4.jpg" alt="Pour" />
                    </Col>
                </Row>
            </div>
        </div>
    );
}

export default ingredients;
